import { render, staticRenderFns } from "./cms-header.vue?vue&type=template&id=4f9520d6&scoped=true&"
import script from "./cms-header.vue?vue&type=script&lang=js&"
export * from "./cms-header.vue?vue&type=script&lang=js&"
import style0 from "./cms-header.vue?vue&type=style&index=0&id=4f9520d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9520d6",
  null
  
)

export default component.exports